import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { GestaoDesconto } from '../models/gestao-desconto';
import { UsuarioLogado } from '../models/usuario-logado';
import { CarregandoService } from '../services/carregando.service';
import { FuncionarioService } from '../services/funcionario.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';
import { CRMHierarquiaUsuarioService } from '../services/crmhierarquia-usuario.service';
import { PremissasService } from '../services/premissas.service';
import { TagGi } from '../models/tag-gi';
import { TagGiService } from '../services/tag-gi.service';
import { PerfilDoUsuario, TipoTag } from '../models/enum';
import { Filtro } from '../models/filtro';
import { IbgeService } from '../services/ibge.service';
import { Ibge } from '../models/ibge';
import { ClienteService } from '../services/cliente.service';
import { Cliente } from '../models/cliente';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AtualizaDA, FiltroDA } from '../models/atualizaDA';
import swal from 'sweetalert2';
import { FiltrosGestaoDeDescontosComponent } from '../modals/filtros-gestao-de-descontos/filtros-gestao-de-descontos.component';
import { ListaGestaoDescontoComponent } from '../modals/lista-gestao-desconto/lista-gestao-desconto.component';
import { LogFiltrosGestaoDescComponent } from '../modals/log-filtros-gestao-desc/log-filtros-gestao-desc.component';
import { PaginatorService } from '../services/paginator.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-gestao-de-descontos',
  templateUrl: './gestao-de-descontos.component.html',
  styleUrls: ['./gestao-de-descontos.component.scss']
})
export class GestaoDeDescontosComponent implements OnInit, AfterViewInit {
  gestao = new GestaoDesconto;
  usuario: UsuarioLogado;
  tagsDoIntegrador: TagGi[] = [];
  tagsSelecionadas: number[];
  PerfilDoUsuario = PerfilDoUsuario;
  perfil: PerfilDoUsuario;
  clientesFiltrados: Cliente[] = [];
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  status = [{ id: false, nome: 'Pendente' }, { id: true, nome: 'Já Cliente' }];
  statusSelecionado = -1;
  dados: AtualizaDA = new AtualizaDA();
  filtroAvancado: FiltroDA = new FiltroDA();

  tiposDeStatus = [{ id: -1, nome: 'Todos' }, { id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  tiposDeDA = [{ id: 0, nome: 'Desconto' }, { id: 1, nome: 'Acréscimo' }];
  tiposDeDASelecionado = 0;
  valorDesc = 0;
  valorAcresc = 0;
  gi = 1;
  pesquisaGeral = true;
  validaAplicar: boolean = true;

  esconderBotao = false;
  tiposPesquisa = [{ id: 0, nome: 'Documento' }, { id: 1, nome: 'Fantasia' }, { id: 2, nome: 'Razão' }, { id: 3, nome: 'Email' }];
  tipoPesquisaSelecionado: number;
  pesquisa: string;

  pesquisarPorVendedor: false;
  idVendedor;
  idFiltro;

  integrador = false;
  administrador = false;
  hide = true;

  tabAlvo = 0;
  tabIndex = 0;

  estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
    'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
  estadoSelecionado = undefined;
  cidades: Ibge[] = [];
  cidadeSelecionada = undefined;

  carregando = true;
  campoOrdenacao = 'apelido';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  podeVerGestaoAvancada;
  limDesc = undefined;

  vendedores = [];
  podeAplicarPara = [];
  naoPodeAplicarPara = [];
  sobreporRegra: boolean = false;

  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private funcionarioService: FuncionarioService,
    private clienteService: ClienteService,
    public utilitarioService: UtilitarioService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private tagService: TagGiService,
    private ibgeService: IbgeService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private premissasService: PremissasService,
    public dialog: MatDialog, private route: ActivatedRoute,
    private paginatorService: PaginatorService
    ) { }


  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
    
    this.administrador = await this.globalService.administrador();
    this.usuario = await this.globalService.consultaUsuario();

    this.premissasService.consultarDescClienteSobreporVendedor().subscribe(resp => {
      this.sobreporRegra = resp.valor;
    });

    this.perfil = await this.globalService.perfil();

    this.dados.tipoDa = this.tiposDeDASelecionado;
    this.dados.valorDA = 0;

    this.buscarGestao();
    this.buscarTags();

    const filtroNomeCliente = document.getElementById('filtroNomeCliente');

    setTimeout(() => {
      filtroNomeCliente.focus();
    }, 500);

    if (this.perfil === PerfilDoUsuario.Suporte || this.perfil === PerfilDoUsuario.Administrador || this.perfil === PerfilDoUsuario.Vendedor) {
      if (this.idVendedor === null || this.idVendedor === undefined) {
        this.idVendedor = this.usuario.id;
      }

      if (this.perfil === PerfilDoUsuario.Suporte || this.perfil === PerfilDoUsuario.Administrador) {
        this.podeVerGestaoAvancada = true;
      } else {
        this.funcionarioService.consultaPodeVerGestaoAvancada(this.usuario.id).subscribe(resp => {
          this.podeVerGestaoAvancada = resp;
        });
      }

      if (this.idVendedor) {
        this.buscarDescontoPorVendedor();
      }

      this.buscarVendedores();
    }

    this.buscarClientes();
  }

  buscarGestao() {
    this.carregandoService.mostra('buscarGestao');

    this.funcionarioService.consultarGestaoDesconto().subscribe(dados => {
      this.gestao = dados;
      this.carregandoService.esconde('buscarGestao');
    }, (erro) => {
      this.carregandoService.esconde('buscarGestao');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarVendedores() {
    if (this.administrador) {
      this.carregandoService.mostra('buscarVendedores');

      this.funcionarioService.consultarFuncionariosPedido().subscribe(resp => {
        this.vendedores = resp.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome, limDesc: Number(p.limDesc) }));

        if (this.vendedores.length > 1) {
          this.vendedores.unshift({ idFuncion: 0, nome: 'Todos', limDesc: 0 });
        }

        this.carregandoService.esconde('buscarVendedores');
      }, (erro) => {
        this.carregandoService.esconde('buscarVendedores');
        this.notificacaoService.erro(erro);
      });
    }
    else {
      this.carregandoService.mostra('buscarVendedoresHierarquia');

      this.hierarquiaService.consultarHierarquiaDoUsuarioLista().subscribe(resp => {
        this.vendedores = resp.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome, limDesc: Number(p.limDesc) }));;

        if (this.vendedores.some(p => p.idFuncion === this.usuario)) {
          this.vendedores.splice(this.vendedores.
            indexOf(this.vendedores.find(p => p.idFuncion === this.usuario)), 1);
        }

        if (this.vendedores.length > 0) {
          const todos = new CRMHierarquiaUsuario();
          todos.idFuncion = 0;
          todos.nome = 'Todos';
          todos.limDesc = 0;
          this.vendedores.unshift(todos);
        }

        this.carregandoService.esconde('buscarVendedoresHierarquia');
      }, (erro) => {
        this.carregandoService.esconde('buscarVendedoresHierarquia');
        this.notificacaoService.erro(erro);
      });
    }
  }

  buscarClientes() {
    if (this.idVendedor) {
      this.buscarDescontoPorVendedor();
    }

    this.carregandoService.mostra('buscaClientes');

    this.clienteService.consultaListaAvancada(this.filtroNome.Valor, this.statusSelecionado === -1 ? undefined : this.statusSelecionado, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.gi, this.tipoPesquisaSelecionado, this.pesquisa, this.idVendedor !== undefined && this.idVendedor !== null,
      this.idVendedor === 0 ? null : this.idVendedor, this.pesquisaGeral, this.estadoSelecionado, this.cidadeSelecionada, this.tagsSelecionadas).subscribe(dados => {
        this.clientesFiltrados = dados.itens;
        this.validaAplicar = true;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaClientes');
      }, (erro) => {
        this.carregandoService.esconde('buscaClientes');
        this.notificacaoService.erro(erro);
      });
  }

  buscarDescontoPorVendedor() {
    this.carregandoService.mostra('buscarDescontoPorVendedor');

    this.funcionarioService.consultarLimitDesc(this.idVendedor).subscribe(
      result => {
        this.limDesc = result;
        this.carregandoService.esconde('buscarDescontoPorVendedor');
      },
      err => {
        this.carregandoService.esconde('buscarDescontoPorVendedor');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra('buscaCidades');
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe((ibges: Ibge[]) => {
      this.cidades = ibges;

      if (nomeCidade) {
        this.cidadeSelecionada = this.cidades.find(s => this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) === this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())) ?
          this.cidades.find(s => this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) === this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())).cidade : undefined;
      }

      this.carregandoService.esconde('buscaCidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaCidades');
    });
  }

  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags(TipoTag.integrador).subscribe(
      (tags) => {
        this.tagsDoIntegrador = tags;
        this.tagsDoIntegrador.unshift({ id: -1, tag: 'Sem tags', icone: 'label_off', cor: '#000', tipo: TipoTag.integrador, somenteApi: false, disabled: false, tipoVinculo: 0 });

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  alterouDaGI(cliente: Cliente) {
    if (cliente.daGI === 0) {
      cliente.acrescimoGI = 0;
    } else {
      cliente.descontoMaximoGI = 0;
    }
  }

  limpaFiltros(flag = 0) {
    this.idVendedor = this.usuario.id;
    this.tagsSelecionadas = [];
    this.statusSelecionado = -1;
    this.estadoSelecionado = null;
    this.cidadeSelecionada = null;
    this.idFiltro = null;
    this.dados.valorDA = 0;
    this.dados.tipoDa = 0;
    this.podeAplicarPara = [];
    this.naoPodeAplicarPara = [];

    if (flag !== 1) {
      this.paginacao = { tamanhoMaximo: 10, total: 0, paginaAtual: 1 };
      this.buscarClientes();
    }
  }

  carregaFiltro() {
    const dialogRef = this.dialog.open(FiltrosGestaoDeDescontosComponent, {
      width: '600px',
      data: {
        idUsuario: this.usuario.id,
        idFiltro: this.idFiltro
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.limpaFiltros(1);

        let filtro: FiltroDA = result;
        this.dados.tipoDa = filtro.tipoDA;
        this.dados.valorDA = filtro.valorDA;

        this.idVendedor = filtro.filtroJson.idVendedor;
        this.tagsSelecionadas = filtro.filtroJson.tags;
        this.statusSelecionado = filtro.filtroJson.status;
        this.estadoSelecionado = filtro.filtroJson.uf;
        this.idFiltro = result.id;

        if (filtro.filtroJson.cidade !== "" && filtro.filtroJson.cidade !== null) {
          this.buscarCidades(filtro.filtroJson.cidade);

          if (this.cidadeSelecionada === undefined)
            this.cidadeSelecionada = filtro.filtroJson.cidade;
        }

        this.paginacao.paginaAtual = 1;
        this.buscarClientes();
      }
    });
  }

  verLogFiltro() {
    const dialogRef = this.dialog.open(LogFiltrosGestaoDescComponent, {
      width: '1200px',
      data: {
        idUsuario: this.usuario.id,
        vendedores: this.vendedores
      },
      panelClass: 'modal-card',
      maxHeight: '100vh',
    });
  }

  salvarGestao() {
    if (this.gestao.descontoTime !== null && this.gestao.descontoTime !== undefined) {
      this.gestao.descontoTime = Number(this.gestao.descontoTime);
    }
    this.carregandoService.mostra('salvarGestao');
    this.funcionarioService.salvarGestaoDesconto(this.gestao).subscribe((retorno) => {
      this.notificacaoService.sucesso('Configuração de Desconto salva com sucesso!!!');
      this.buscarGestao();
      this.carregandoService.esconde('salvarGestao');
    }, (erro) => {
      this.carregandoService.esconde('salvarGestao');
      this.notificacaoService.erro(erro);
    });
  }

  salvaFiltro() {
    if (
      [this.dados.tipoDa, this.dados.valorDA, this.cidadeSelecionada, this.estadoSelecionado]
          .every((value) => value === undefined || value === null) &&
      this.statusSelecionado === -1 &&
      (this.tagsSelecionadas === undefined || this.tagsSelecionadas.length === 0)
    ) {
      swal({
        title: 'Atenção!',
        text: 'Por favor, insira os filtros antes de salvar.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    }
    else {
      swal({
        title: 'Nome do filtro:',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Salvar',
        showLoaderOnConfirm: true,
        preConfirm: (descricao) => {
          if (descricao.replace(" ", "") === "") {
            this.notificacaoService.erro('Por favor, insira uma descrição antes de salvar os filtros.');
          }
          else {
            const filtro = {
              idVendedor: this.idVendedor,
              tags: this.tagsSelecionadas,
              status: this.statusSelecionado,
              uf: this.estadoSelecionado,
              cidade: this.cidadeSelecionada
            };

            this.filtroAvancado.descricao = descricao;
            this.filtroAvancado.idusuario = this.usuario.id;
            this.filtroAvancado.tipoDA = this.dados.tipoDa;
            this.filtroAvancado.valorDA = this.dados.valorDA !== null && this.dados.valorDA !== undefined ? Number(this.dados.valorDA) : 0;
            this.filtroAvancado.filtroJson = filtro;

            this.carregandoService.mostra('salvaFiltro');
            this.funcionarioService.salvarFiltroGestaoDesconto(this.filtroAvancado).subscribe(resp => {
              this.notificacaoService.sucesso('Filtro salvo com sucesso');
              this.carregandoService.esconde('salvaFiltro');
            }, (erro) => {
              this.notificacaoService.erro(erro);
              this.carregandoService.esconde('salvaFiltro');
            });
          }
        },
      });
    }
  }

  aplicarDescontoFiltros(vendAprovados: number[] = [], flag = false) {
    let naoAplicar = false;

    let filtro = {
      idVendedor: this.idVendedor,
      tags: this.tagsSelecionadas,
      status: this.statusSelecionado,
      uf: this.estadoSelecionado,
      cidade: this.cidadeSelecionada,
      vendedores: []
    };

    if (vendAprovados.length === 0 && !flag && this.idVendedor === 0) {
      this.dados.ids = this.clientesFiltrados.map(e => e.id);
      filtro.vendedores = this.vendedores.filter(v => v.idFuncion !== 0).map(v => v.idFuncion);
    } else if (vendAprovados.length > 0 && !flag) {
      this.dados.ids = [];
      filtro.vendedores = vendAprovados;
    } else if (vendAprovados.length === 0 && flag) {
      naoAplicar = true;
    }

    this.dados.tipoDa = this.tiposDeDASelecionado;
    this.dados.valorDA = this.dados.valorDA !== null && this.dados.valorDA !== undefined ? Number(this.dados.valorDA) : 0;
    const textoDA = this.tiposDeDA.find(e => e.id === this.tiposDeDASelecionado).nome.toString();

    this.dados.filtroJson = filtro;
    this.dados.idusuario = this.usuario.id;
    this.dados.nomeUsuario = this.usuario.nome;

    if (naoAplicar) {
      this.notificacaoService.erro("O valor não pode ser aplicado a nenhum registro");
    }
    else {
      this.carregandoService.mostra('atualizaDA');

      this.clienteService.atualizarDA(this.dados).subscribe(() => {
        this.notificacaoService.sucesso(`Valor de ${textoDA} Atualizado.`);

        this.buscarClientes();
        this.carregandoService.esconde('atualizaDA');
      }, (erro) => {
        this.carregandoService.esconde('atualizaDA');
        this.notificacaoService.erro(erro);
      });
    }
  }

  validaFiltro() {
    if (this.tiposDeDASelecionado === 0 && this.idVendedor != null && this.idVendedor !== undefined && this.dados.valorDA !== 0) {
      this.naoPodeAplicarPara = [];
      this.podeAplicarPara = [];

      if (this.idVendedor !== 0) {
        const vendedorSelecionado = this.vendedores.find(v => v.idFuncion === this.idVendedor);

        //Verificar validador Angelo
        if (this.dados.valorDA > vendedorSelecionado.limDesc && this.clientesFiltrados.length > 0 && !this.sobreporRegra) {
          swal({
            title: 'Atenção!',
            text: `O desconto excede o limite permitido para o vendedor ${vendedorSelecionado.nome} (${vendedorSelecionado.limDesc}%).`,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning'
          }).catch(swal.noop);

          this.dados.valorDA = 0;
          this.validaAplicar = true;
        } else {
          this.confirmar();
        }
      } else {
        //Verificar validador Angelo
        if (!this.sobreporRegra) {
          this.vendedores.forEach(v => {
            if (v.idFuncion !== 0)
              if (Number(this.dados.valorDA) > v.limDesc)
                this.naoPodeAplicarPara.unshift(v);
              else
                this.podeAplicarPara.unshift(v.idFuncion);
          });
        } else {
          this.vendedores.forEach(v => {
            if (v.idFuncion !== 0)
              this.podeAplicarPara.unshift(v.idFuncion);
          });
        }

        if (this.naoPodeAplicarPara.length > 0) {
          const dialogRef = this.dialog.open(ListaGestaoDescontoComponent, {
            width: '600px',
            data: {
              lista: this.naoPodeAplicarPara
            },
            panelClass: 'modal-card'
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              if (this.podeAplicarPara.length === 0)
                this.aplicarDescontoFiltros(this.podeAplicarPara, true);
              else
                this.aplicarDescontoFiltros(this.podeAplicarPara);
            }
          });

          this.validaAplicar = true;
        }
        else
          this.confirmar();
      }
    }
    else
      this.clientesFiltrados.length > 0 ? this.confirmar() : true;
  }

  confirmar() {
    if (this.clientesFiltrados.length > 0) {
      swal({
        title: 'Atenção!!',
        text: `Deseja realmente aplicar este ${this.dados.tipoDa === 0 ? 'desconto': 'acréscimo'}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false
      }).then((result) => {
        if(result.value)
          if (!this.sobreporRegra)
            this.aplicarDescontoFiltros();
          else
            this.aplicarDescontoFiltros(this.podeAplicarPara);

      });
    } else {
      swal({
        title: 'Atenção!',
        text: `Não existe registro para aplicar o ${this.dados.tipoDa === 0 ? 'desconto': 'acréscimo'}.`,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    }
  }

  limparDesc() {
    if (this.tiposDeDASelecionado === 0 && this.dados.tipoDa === 1 ) {
      this.dados.valorDA = 0;
      this.dados.tipoDa = 0;
    } else if (this.tiposDeDASelecionado === 1 && this.dados.tipoDa === 0 ) {
      this.dados.valorDA = 0;
      this.dados.tipoDa = 1;
    }
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarClientes();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarClientes();
    this.paginator.firstPage();
  }

  ngAfterViewInit() {
    const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');

    // Wizard Initialization
    $('.card-wizard').bootstrapWizard({
      'tabClass': 'nav nav-pills',
      'nextSelector': '.btn-next',
      'previousSelector': '.btn-previous',

      onNext: function (tab, navigation, index) {
      },

      onInit: function (tab: any, navigation: any, index: any) {

        // check number of tabs and fill the entire row
        let $total = navigation.find('li:not(.d-none)').length;
        let $wizard = navigation.closest('.card-wizard');

        let $first_li = navigation.find('li:first-child a').html();
        let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
        $('.card-wizard .wizard-navigation').append($moving_div);

        $total = $wizard.find('.nav li:not(.d-none)').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li:not(.d-none)').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        let $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
        });
        $('.moving-tab').css('transition', 'transform 0s');
      },

      onTabClick: (tab: any, navigation: any, index: any) => {
        if (this.tabIndex !== this.tabAlvo) {
          this.tabIndex = this.tabAlvo;
          return true;
        }

        return false;
      },

      onTabShow: (tab: any, navigation: any, index: any) => {
        let $total = navigation.find('li:not(.d-none)').length;
        let $current = index + 1;
        elemMainPanel.scrollTop = 0;
        const $wizard = navigation.closest('.card-wizard');

        // If it's the last tab then hide the last button and show the finish instead
        if ($current >= $total) {
          $($wizard).find('.btn-next').hide();
          $($wizard).find('.btn-finish').show();
        } else {
          $($wizard).find('.btn-next').show();
          $($wizard).find('.btn-finish').hide();
        }

        const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

        setTimeout(function () {
          $('.moving-tab').text(button_text);
        }, 150);

        const checkbox = $('.footer-checkbox');

        if (index !== 0) {
          $(checkbox).css({
            'opacity': '0',
            'visibility': 'hidden',
            'position': 'absolute'
          });
        } else {
          $(checkbox).css({
            'opacity': '1',
            'visibility': 'visible'
          });
        }
        $total = $wizard.find('.nav li:not(.d-none)').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li:not(.d-none)').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
        });
      }
    });

    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader = new FileReader();

        reader.onload = function (e: any) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-radio"]').click(function () {
      const wizard = $(this).closest('.card-wizard');
      wizard.find('[data-toggle="wizard-radio"]').removeClass('active');
      $(this).addClass('active');
      $(wizard).find('[type="radio"]').removeAttr('checked');
      $(this).find('[type="radio"]').attr('checked', 'true');
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

    this.rodaScriptTabEnter();

    $(window).resize(() => {
      $('.card-wizard').each(function () {
        setTimeout(() => {
          const $wizard = $(this);
          const index = $wizard.bootstrapWizard('currentIndex');
          let $total = $wizard.find('.nav li:not(.d-none)').length;
          let $li_width = 100 / $total;

          let total_steps = $wizard.find('.nav li:not(.d-none)').length;
          let move_distance = $wizard.width() / total_steps;
          let index_temp = index;
          let vertical_level = 0;

          let mobile_device = $(document).width() < 600 && $total > 3;
          if (mobile_device) {
            move_distance = $wizard.width() / 2;
            index_temp = index % 2;
            $li_width = 50;
          }

          $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

          let step_width = move_distance;
          move_distance = move_distance * index_temp;

          let $current = index + 1;

          if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
            move_distance -= 8;
          } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
            move_distance += 8;
          }

          if (mobile_device) {
            let x: any = index / 2;
            vertical_level = parseInt(x);
            vertical_level = vertical_level * 38;
          }

          $wizard.find('.moving-tab').css('width', step_width);
          $('.moving-tab').css({
            'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
            'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
          });

          $('.moving-tab').css({
            'transition': 'transform 0s'
          });
        }, 500);

      });
    });
  }

  defineTabAlvo(alvo) {
    this.tabAlvo = alvo;
  }

  // atualiza o tabIndex
  proximaTab(e) {
    e.preventDefault();
    this.tabIndex++;
  }

  tabAnterior(e) {
    e.preventDefault();
    this.tabIndex--;
  }

  rodaScriptTabEnter() {
    this.utilitarioService.rodaScriptTabEnter();
  }
}